module.exports = __webpack_public_path__ + "media/images/cheers_sent_success_5-3c3418240cca2c51221502116ad417a7.gif";